"use strict";
class WrapperAccordion {
    constructor(selector, openedWidth, closedWidth, skip) {
        this.warpperElmList = document.querySelectorAll(selector);
        this.maxWidthOpened = openedWidth;
        this.maxWidthClosed = closedWidth;
        this.skip = skip;
        this.iniWrapperAccordion();
    }
    iniWrapperAccordion() {
        if (this.warpperElmList && this.warpperElmList.length > 0) {
            this.closeAllAccordion(Array.from(this.warpperElmList));
            this.warpperElmList.forEach((el, ind) => {
                if (ind + 2 >= this.skip) {
                    this.listenToElement(el, this.wrapperAccordionController.bind(this));
                }
            });
        }
    }
    wrapperAccordionController(evt, elm) {
        const isOpened = elm.dataset.isOpened;
        if (isOpened === 'true') {
            this.closeAccordion(elm, this.maxWidthClosed);
        }
        else {
            this.openAccordion(elm, this.maxWidthOpened);
        }
    }
    listenToElement(elm, handler) {
        const firstChild = elm.firstElementChild;
        if (!firstChild)
            return;
        firstChild.addEventListener('click', (evt) => {
            handler(evt, elm);
        });
    }
    closeAllAccordion(elmArray) {
        elmArray.forEach((el, ind) => {
            if (ind + 1 >= this.skip) {
                this.closeAccordion(el, this.maxWidthClosed);
            }
        });
    }
    openAccordion(elm, maxHeight) {
        const contentWrapper = elm.querySelector('.accordion_contentWrapper');
        console.log(contentWrapper);
        contentWrapper === null || contentWrapper === void 0 ? void 0 : contentWrapper.classList.add("open");
        this.markOpened(elm);
    }
    closeAccordion(elm, maxHeight) {
        const contentWrapper = elm.querySelector('.accordion_contentWrapper');
        contentWrapper === null || contentWrapper === void 0 ? void 0 : contentWrapper.classList.remove("open");
        this.markClosed(elm);
    }
    markOpened(elm) {
        elm.dataset.isOpened = "true";
    }
    markClosed(elm) {
        delete elm.dataset.isOpened;
    }
}
const descriptionWrapper = new WrapperAccordion('.product_description_wrapper', 600, 55, 0);
const cartPoliciesWrapper = new WrapperAccordion('.cart_policy_wrapper', 1500, 55, 0);
